import Header from "./header"

import "./upsell.scss"

export interface TrialConfigUrls {
  proSubscriptionsUrl: string
  proPlusSubscriptionsUrl: string
}

export interface TrialConfigAssets {
  proIllustration: string
  proStudentIllustration: string
}
interface Props {
  onSkip: () => void
  onClickBack: () => void
  trialConfig: {
    assets: TrialConfigAssets
    urls: TrialConfigUrls
  }
  userIsStudent: boolean
}

const Upsell = ({ onSkip, trialConfig, onClickBack, userIsStudent }: Props) => {
  const title = userIsStudent ? "Pro+ student discount" : "Start your trial"
  const body = userIsStudent
    ? "Save 90% on your subscription and get full access to popular Applets and features. Make your favorite things work better together."
    : "Subscribe to get full access to popular Applets and features. Make your favorite things work better together."
  const url = userIsStudent ? trialConfig.urls.proPlusSubscriptionsUrl : trialConfig.urls.proSubscriptionsUrl

  return (
    <>
      <Header title="" onClickBack={onClickBack} page="trial" />
      <div styleName="container">
        <section styleName="welcome">
          {userIsStudent ? (
            <img src={trialConfig.assets.proStudentIllustration} alt="Subscribe to get full access" />
          ) : (
            <img src={trialConfig.assets.proIllustration} alt="Try Pro for Free" />
          )}
          <h1>{title}</h1>
          <p>{body}</p>
        </section>

        <div className="flexbox">
          <section styleName="action-buttons-container" className="action-buttons-container">
            <a href={url} role="button" data-turbolinks="false" className="button-primary pay-later">
              {userIsStudent ? "Claim deal" : "Continue"}
            </a>

            <a onClick={onSkip} styleName="skip-pro-link">
              Not now
            </a>
          </section>
        </div>
      </div>
    </>
  )
}

export default Upsell
